import { render, staticRenderFns } from "./admin-sales-forecast.vue?vue&type=template&id=e2cd916a&scoped=true&"
import script from "./admin-sales-forecast.vue?vue&type=script&lang=js&"
export * from "./admin-sales-forecast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cd916a",
  null
  
)

export default component.exports